import React from "react";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import TableActionButton from "../Reusable/TableActionButton";
import SwitchButton from "../Reusable/SwitchButton";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";
import usePermission from "../../customHooks/usePermission";
import { useNavigate } from "react-router-dom";

const StatusList = (props: any) => {
  const {
    handleIsActive,
    handleIsRTV,
    handleIsFinalState,
    handleIsEnableSMS,
    handleIsEnableEmail,
    handleIsEnablePartial,
    handleIsCreateInvoice,
    handleCal_Cod,
  } = props;
  const canUpdateSetting = usePermission({
    allowedPermissions: ["can_update_setting"],
  });
  const navigate = useNavigate();
  const handleRowClick = (row: any) => {
    if (!canUpdateSetting) return;
    navigate(`edit/${row?.original?.id}`);
  };
  console.log(canUpdateSetting);
  const defaultColumns: any = [
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "Color",
      accessorKey: "color",
      cell: ({ row, getValue }: any) => {
        return (
          <div
            className={tw`h-4 w-16`}
            style={{ background: getValue() }}
          ></div>
        );
      },
    },
    {
      header: "Calculate Cod",
      accessorKey: "calc_collected_cod",
      cell: ({ row, getValue }) => (
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <SwitchButton
            id={row?.original?.id}
            value={getValue()}
            disabled={false}
            onChange={handleCal_Cod}
          />
        </div>
      ),
    },
    {
      header: "SMS",
      accessorKey: "is_enable_sms",
      cell: ({ row, getValue }) => (
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <SwitchButton
            id={row?.original?.id}
            value={getValue()}
            disabled={false}
            onChange={handleIsEnableSMS}
          />
        </div>
      ),
    },
    {
      header: "Email",
      accessorKey: "is_enable_email",
      cell: ({ row, getValue }) => (
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <SwitchButton
            id={row?.original?.id}
            value={getValue()}
            disabled={false}
            onChange={handleIsEnableEmail}
          />
        </div>
      ),
    },
    {
      header: "Partial",
      accessorKey: "is_partial_status",
      cell: ({ row, getValue }) => (
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <SwitchButton
            id={row?.original?.id}
            value={getValue()}
            disabled={false}
            onChange={handleIsEnablePartial}
          />
        </div>
      ),
    },
    {
      header: "Invoice",
      accessorKey: "is_create_invoice",
      cell: ({ row, getValue }) => (
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <AccessControl
            children={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={false}
                onChange={handleIsCreateInvoice}
              />
            }
            allowedPermissions={["can_update_setting"]}
            renderNoAccess={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={true}
                onChange={handleIsCreateInvoice}
              />
            }
          />
        </div>
      ),
    },
    {
      header: "Active",
      accessorKey: "is_active",
      cell: ({ row, getValue }) => (
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <AccessControl
            children={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={false}
                onChange={handleIsActive}
              />
            }
            allowedPermissions={["can_update_setting"]}
            renderNoAccess={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={true}
                onChange={handleIsActive}
              />
            }
          />
        </div>
      ),
    },
    {
      header: "Allow RTV Order",
      accessorKey: "is_allow_to_create_rtv",
      cell: ({ row, getValue }) => (
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <AccessControl
            children={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={false}
                onChange={handleIsRTV}
              />
            }
            allowedPermissions={["can_update_setting"]}
            renderNoAccess={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={true}
                onChange={handleIsRTV}
              />
            }
          />
        </div>
      ),
    },
    {
      header: "Is Final State",
      accessorKey: "is_final_state",
      cell: ({ row, getValue }) => (
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <AccessControl
            children={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={false}
                onChange={handleIsFinalState}
              />
            }
            allowedPermissions={["can_update_setting"]}
            renderNoAccess={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={true}
                onChange={handleIsFinalState}
              />
            }
          />
        </div>
      ),
    },
    // {
    //   header: "Action",
    //   accessorKey: "id",
    //   cell: ({ row, getValue }: any) => (
    //     <>
    //       <AccessControl
    //         children={<TableActionButton editPath={`edit/${getValue()}`} />}
    //         allowedPermissions={["can_update_setting"]}
    //       />
    //     </>
    //   ),
    // },
  ];
  return (
    <DataTable
      handleRowClick={handleRowClick}
      url={APIS.STATUS}
      queryKey={"status"}
      columns={defaultColumns}
      addNewPagePath={null}
      tableName={"status"}
    />
  );
};

export default StatusList;
